import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#030308]">
      <div className="bg-[#0A0A12] border-b border-white/10">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
          <Link to="/">
            <Button variant="ghost" className="text-slate-400 hover:text-indigo-400 hover:bg-transparent p-0">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
          <span className="text-sm text-slate-500 font-normal uppercase tracking-wider" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Trademark My LLC
          </span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Privacy Policy
        </h1>
        <p className="text-sm text-slate-500 mb-12">Last Updated: February 2026</p>

        <div className="space-y-8 text-slate-400 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>1. Information We Collect</h2>
            <p className="text-sm">
              Trademark My LLC collects personal information that you provide directly, including your name, email address, phone number, and details about your trademark registration needs. We also collect usage data through cookies and similar technologies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>2. How We Use Your Information</h2>
            <p className="text-sm">
              We use the information we collect to provide our trademark registration services, communicate with you about your case, send service updates, improve our website and services, and comply with legal obligations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>3. Information Sharing</h2>
            <p className="text-sm">
              We do not sell your personal information to third parties. We may share information with trusted service providers who assist in operating our website and delivering our services, or when required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>4. Data Security</h2>
            <p className="text-sm">
              We implement appropriate technical and organizational security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>5. Your Rights</h2>
            <p className="text-sm">
              You have the right to access, correct, or delete your personal information. You may also opt out of marketing communications at any time. To exercise these rights, contact us at info@trademarkmyllc.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>6. Cookies</h2>
            <p className="text-sm">
              Our website uses cookies to enhance your browsing experience. You can control cookie preferences through your browser settings. Some cookies are essential for the website to function properly.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>7. Contact Us</h2>
            <p className="text-sm">
              For any questions about this Privacy Policy, please contact us at info@trademarkmyllc.com or call +1 (800) 123-4567.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
